import React from 'react';
import StepActions from './StepActions';
import StepContent from './StepContent';
import StepDescription from './StepDescription';
import StepImage from './StepImage';
import StepLabel from './StepLabel';
import StepTitle from './StepTitle';
import styles from './consultancyStep.module.css';
import type { LandpageStepImagePosition } from '../../landpage.constants';

interface ConsultancyStepCardProps {
  step: string;
  title: string;
  description: React.ReactNode;
  imageSrc: string;
  imageAlt: string;
  imagePosition: LandpageStepImagePosition;
  imageObjectPosition?: string;
  imageRightCropPx?: number;
  actions?: React.ReactNode;
  children?: React.ReactNode;
  titleClassName?: string;
  descriptionClassName?: string;
  actionsClassName?: string;
}

const ConsultancyStepCard: React.FC<ConsultancyStepCardProps> = ({
  step,
  title,
  description,
  imageSrc,
  imageAlt,
  imagePosition,
  imageObjectPosition,
  imageRightCropPx,
  actions,
  children,
  titleClassName,
  descriptionClassName,
  actionsClassName,
}) => {
  const image = (
    <StepImage
      src={imageSrc}
      alt={imageAlt}
      objectPosition={imageObjectPosition}
      rightCropPx={imageRightCropPx}
    />
  );
  const content = (
    <StepContent>
      <StepLabel>{step}</StepLabel>
      <StepTitle className={titleClassName}>{title}</StepTitle>
      <StepDescription className={descriptionClassName}>{description}</StepDescription>
      {children}
      {actions && <StepActions className={actionsClassName}>{actions}</StepActions>}
    </StepContent>
  );

  return (
    <div
      className={`${styles.card} ${
        imagePosition === 'left' ? styles.cardImageLeft : styles.cardImageRight
      }`}
    >
      {imagePosition === 'left' ? (
        <>
          {image}
          {content}
        </>
      ) : (
        <>
          {content}
          {image}
        </>
      )}
    </div>
  );
};

export default ConsultancyStepCard;
